module.exports = __webpack_public_path__ + "img/nobody_bg.34fa7746.png";